import React, { useEffect, useRef, useState, Fragment } from "react";
import "../../../components/styles/style.css";
import "../../../components/styles/professionalEditar.styles.css";

import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";

import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import InputMask from "react-input-mask";
import NumberFormat from "react-number-format";
import CpfCnpj from "@react-br-forms/cpf-cnpj-mask";
import Swal from "sweetalert2";
import axios from "axios";
import imgAp from "../../../assets/img/imgLogin.jpg";

import Header from "../../../components/header";
import Footer from "../../../components/footer";
import { Checkbox as StyledCheckbox } from "../../../components/checkbox";
import { CircularProgress } from "../../../components/circularProgress";

import * as SignupServices from "../../../services/api/SignupServices";
import * as ProfessionalsServices from "../../../services/api/ProfessionalsServices";
import * as AttendenceMethodsServices from "../../../services/api/Attendence-methodsServices";
import * as InsurancesServices from "../../../services/api/InsurancesServices";
import * as SpecialitiesServices from "../../../services/api/SpecialitiesServices";
import { userSignIn } from "../../../redux/actions/authActions";
import { useUserContext } from "../../../providers/useUserContext";
import { formatPhone, phoneDigits, phoneMask } from "../../../utils/phone";

const UPLOAD_ENDPOINT = "https://files.minhafono.com.br/upload.php";

const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{6,}$/;

const profFormation = [
  { label: "FONOAUDIOLOGIA", value: "FONOAUDIOLOGIA" },
  { label: "PSICOLOGIA", value: "PSICOLOGIA" },
  { label: "PEDAGOGIA", value: "PEDAGOGIA" },
  { label: "FISIOTERAPIA", value: "FISIOTERAPIA" },
];

const profTitle = [
  { label: "GRADUAÇÃO", value: "GRADUAÇÃO" },
  { label: "ESPECIALIZAÇÃO", value: "ESPECIALIZAÇÃO" },
  { label: "MESTRADO", value: "MESTRADO" },
  { label: "DOUTORADO", value: "DOUTORADO" },
  { label: "PÓS-DOUTORADO", value: "POS-DOUTORADO" },
];

const PERIODS = [
  { value: "Morning", label: "Manhã" },
  { value: "Afternoon", label: "Tarde" },
  { value: "Night", label: "Noite" },
];

const phoneSchema = Yup.string().test(
  "phone-length",
  "Telefone inválido",
  (value) => !value || [10, 11].includes(phoneDigits(value).length)
);

const emptyClinic = () => ({
  clinic_name: "",
  clinic_contact: "",
  zipcode: "",
  street: "",
  number: "",
  district: "",
  complement: "",
  state: "",
  city: "",
});

const clinicSchema = Yup.object().shape({
  clinic_name: Yup.string().required("Obrigatório"),
  clinic_contact: phoneSchema.required("Obrigatório"),
  zipcode: Yup.string().required("Obrigatório"),
  street: Yup.string().required("Obrigatório"),
  number: Yup.string().required("Obrigatório"),
  district: Yup.string().required("Obrigatório"),
  city: Yup.string().required("Obrigatório"),
  state: Yup.string().required("Obrigatório"),
  complement: Yup.string(),
});

const signupSchema = Yup.object().shape({
  name: Yup.string().max(255).required("Preencha com um nome válido"),
  email: Yup.string()
    .email("Preencha um e-mail válido")
    .max(255)
    .required("Preencha um e-mail válido"),
  password: Yup.string()
    .required("Preencha uma senha válida")
    .matches(
      PASSWORD_REGEX,
      "Mínimo de 6 caracteres, ao menos uma letra maiúscula, um número e um caractere especial."
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "As senhas devem corresponder")
    .required("Confirme a senha"),
  crfa: Yup.string()
    .max(255)
    .required("Preencha o número de conselho de classe"),
  cpf_cnpj: Yup.string().required("Preencha o CPF/CNPJ"),
  formation: Yup.string().required("Selecione a formação acadêmica"),
  title: Yup.string().required("Selecione a titulação máxima"),
  phone: phoneSchema.required("Preencha o telefone"),
  whatsapp: Yup.string().required("Preencha o WhatsApp"),
  picture: Yup.string().required("A foto é obrigatória"),
  description: Yup.string(),
  clinicAddresses: Yup.array()
    .of(clinicSchema)
    .min(1, "Informe ao menos um consultório"),
});

const useStyles = makeStyles((theme) => ({
  page: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(6, 2),
    "@media (max-width: 600px)": {
      padding: theme.spacing(3, 1.5),
    },
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: 920,
    backgroundColor: "#fff",
    borderRadius: 16,
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.06)",
    padding: theme.spacing(5, 6),
    "@media (max-width: 600px)": {
      padding: theme.spacing(3, 2.5),
    },
  },
  titulo: {
    color: "#54B5CF",
    fontFamily: "Montserrat",
    fontSize: "32px",
    fontWeight: 800,
    marginBottom: 4,
    textAlign: "center",
    "@media (max-width: 600px)": { fontSize: "24px" },
  },
  sectionTitle: {
    color: "#54B5CF",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontWeight: 700,
    margin: "28px 0 6px 0",
  },
  label: {
    fontSize: 13,
    color: "#54B5CF",
    fontFamily: "Roboto",
    fontWeight: 600,
    marginTop: 14,
  },
  hint: {
    fontSize: 12,
    color: "#9aa0a6",
    fontFamily: "Roboto",
  },
  hintCenter: {
    fontSize: 12,
    color: "#9aa0a6",
    fontFamily: "Roboto",
    textAlign: "center",
    marginBottom: 8,
  },
  required: { color: "#ff5e8f" },
  photoBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  avatar: {
    width: 150,
    height: 150,
    borderRadius: "50%",
    objectFit: "cover",
    border: "4px solid #eef6f9",
    boxShadow: "0 4px 14px rgba(84, 181, 207, 0.25)",
  },
  uploadButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
    marginTop: 12,
    padding: "8px 18px",
    borderRadius: 24,
    border: "1.5px solid #54B5CF",
    backgroundColor: "#fff",
    color: "#54B5CF",
    fontFamily: "Roboto",
    fontWeight: 600,
    fontSize: 13,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#54B5CF",
      color: "#fff",
    },
  },
  addClinicBox: {
    display: "flex",
    justifyContent: "center",
    marginTop: 12,
  },
  submit: {
    marginTop: 30,
    borderRadius: "30px",
    fontSize: "18px",
    fontWeight: 400,
    fontFamily: "Roboto",
    backgroundColor: "#54B5CF",
    padding: "10px 30px",
    color: "#F8F8FA",
    "&:hover": { backgroundColor: "#0facc4", color: "#fff" },
  },
  clinicBox: {
    borderStyle: "outset",
    borderColor: "#54B5CF",
    borderRadius: "10px",
    margin: "12px 0",
    padding: "8px 16px 24px 16px",
  },
}));

export default function Registro() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useUserContext();

  const [imagePreview, setImagePreview] = useState("");
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const signingUpRef = useRef(false);

  const [attendenceMethods, setAttendenceMethods] = useState([]);
  const [insurances, setInsurances] = useState([]);
  const [specialities, setSpecialities] = useState([]);

  useEffect(() => {
    if (user && !signingUpRef.current) {
      history.push("/admin/profissional/perfil");
    }
  }, [user, history]);

  useEffect(() => {
    (async () => {
      try {
        const [methods, insur, spec] = await Promise.all([
          AttendenceMethodsServices.get(),
          InsurancesServices.get(),
          SpecialitiesServices.get(),
        ]);
        setAttendenceMethods(methods.data || []);
        setInsurances(insur.data || []);
        setSpecialities(spec.data || []);
      } catch (error) {
        console.error("Erro ao carregar listas do cadastro", error);
      }
    })();
  }, []);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      crfa: "",
      cpf_cnpj: "",
      formation: "",
      title: "",
      phone: "",
      whatsapp: "",
      picture: "",
      description: "",
      clinicAddresses: [emptyClinic()],
      insurance: [],
      attendance: [],
      attendanceMethods: [],
      specialities: [],
    },
    validationSchema: signupSchema,
    onSubmit: handleSubmit,
  });

  const { values, errors, touched, setFieldValue, handleChange, handleBlur } =
    formik;

  async function handleSubmit(data) {
    if (emailExists) {
      Swal.fire({
        icon: "error",
        title: "Este e-mail já está cadastrado.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
      });
      return;
    }

    setSubmitting(true);

    const payload = {
      name: data.name,
      email: data.email,
      password: data.password,
      crfa: data.crfa,
      cpf_cnpj: data.cpf_cnpj,
      phone: formatPhone(data.phone),
      whatsapp: data.whatsapp,
      formation: data.formation,
      title: data.title,
      picture: data.picture,
      description: data.description || "",
      clinicAddresses: data.clinicAddresses.map((clinic) => ({
        clinic_name: clinic.clinic_name,
        clinic_contact: formatPhone(clinic.clinic_contact),
        zipcode: clinic.zipcode,
        street: clinic.street,
        number: String(clinic.number),
        district: clinic.district,
        city: clinic.city,
        state: clinic.state,
        complement: clinic.complement || "",
      })),
      insurances: data.insurance,
      attendanceMethods: data.attendanceMethods.map((method) => ({
        attendenceMethodId: method.attendenceMethodId,
        value: method.value || "",
        schedule: method.schedule || "",
        period: method.period || [],
      })),
      specialities: data.specialities.map((speciality) => ({
        specialityId: speciality.specialityId,
        attendenceMethodId: speciality.attendenceMethodId,
        type: speciality.type || "",
      })),
    };

    try {
      await SignupServices.create(payload);
      signingUpRef.current = true;

      await dispatch(
        userSignIn({ email: data.email, password: data.password })
      );

      await Swal.fire({
        icon: "success",
        title: "Seu cadastro foi concluído com sucesso!",
        confirmButtonColor: "#54B5CF",
      });

      // Navegação completa (e não history.push) para que o guard de rota
      // releia a sessão recém-criada do localStorage e não caia em tela branca.
      window.location.assign("/admin/profissional/perfil");
    } catch (error) {
      const status = error?.response?.status;
      const message =
        status === 409
          ? "Este e-mail já está cadastrado."
          : error?.response?.data?.message ||
            "Não foi possível concluir o cadastro. Tente novamente.";

      Swal.fire({
        icon: "error",
        title: Array.isArray(message) ? message[0] : message,
        confirmButtonColor: "#54B5CF",
      });
    } finally {
      setSubmitting(false);
    }
  }

  const markAllTouched = () => {
    const touchedFields = {
      name: true,
      email: true,
      password: true,
      confirmPassword: true,
      crfa: true,
      cpf_cnpj: true,
      formation: true,
      title: true,
      phone: true,
      whatsapp: true,
      picture: true,
      clinicAddresses: values.clinicAddresses.map(() => ({
        clinic_name: true,
        clinic_contact: true,
        zipcode: true,
        street: true,
        number: true,
        district: true,
        city: true,
        state: true,
      })),
    };
    formik.setTouched(touchedFields, false);
  };

  const onClickSubmit = async () => {
    const validationErrors = await formik.validateForm();
    markAllTouched();

    if (Object.keys(validationErrors).length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Preencher campos obrigatórios sinalizados com *",
        confirmButtonColor: "#54B5CF",
      });
      return;
    }

    formik.handleSubmit();
  };

  const handlePhoto = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setImagePreview(URL.createObjectURL(file));
    setUploadingPhoto(true);

    const formData = new FormData();
    formData.append("fileToUpload", file);

    axios
      .post(UPLOAD_ENDPOINT, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        setFieldValue("picture", res.data.file_url);
        Swal.fire({
          icon: "success",
          title: "Foto enviada!",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
        });
      })
      .catch(() => {
        setImagePreview("");
        Swal.fire({
          icon: "error",
          title: "Erro ao enviar a imagem!",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
        });
      })
      .finally(() => setUploadingPhoto(false));
  };

  const handleBlurEmail = async (event) => {
    handleBlur(event);
    const email = event.target.value;
    if (!email) return;
    try {
      const result = await ProfessionalsServices.getByMail(email);
      setEmailExists(result.data.length > 0);
    } catch (error) {
      setEmailExists(false);
    }
  };

  const checkCEP = (event, index) => {
    const cep = event.target.value.replace(/\D/g, "");
    if (!cep) return;
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json())
      .then((address) => {
        if (address.erro) return;
        setFieldValue(`clinicAddresses[${index}].state`, address.uf);
        setFieldValue(`clinicAddresses[${index}].district`, address.bairro);
        setFieldValue(`clinicAddresses[${index}].street`, address.logradouro);
        setFieldValue(`clinicAddresses[${index}].city`, address.localidade);
      })
      .catch((err) => console.log(err));
  };

  const addClinic = () => {
    setFieldValue("clinicAddresses", [
      ...values.clinicAddresses,
      emptyClinic(),
    ]);
  };

  const removeClinic = (index) => {
    setFieldValue(
      "clinicAddresses",
      values.clinicAddresses.filter((_, i) => i !== index)
    );
  };

  const toggleInsurance = (id) => {
    const exists = values.insurance.includes(id);
    setFieldValue(
      "insurance",
      exists
        ? values.insurance.filter((item) => item !== id)
        : [...values.insurance, id]
    );
  };

  const toggleAttendance = (id) => {
    const exists = values.attendance.includes(id);
    if (exists) {
      setFieldValue(
        "attendance",
        values.attendance.filter((item) => item !== id)
      );
      setFieldValue(
        "attendanceMethods",
        values.attendanceMethods.filter((m) => m.attendenceMethodId !== id)
      );
      setFieldValue(
        "specialities",
        values.specialities.filter((s) => s.attendenceMethodId !== id)
      );
    } else {
      setFieldValue("attendance", [...values.attendance, id]);
      setFieldValue("attendanceMethods", [
        ...values.attendanceMethods,
        { attendenceMethodId: id, value: "", schedule: "", period: [] },
      ]);
    }
  };

  const togglePeriod = (methodIndex, periodValue) => {
    const method = values.attendanceMethods[methodIndex];
    const exists = method.period.includes(periodValue);
    const period = exists
      ? method.period.filter((p) => p !== periodValue)
      : [...method.period, periodValue];
    setFieldValue(`attendanceMethods[${methodIndex}].period`, period);
  };

  const toggleSpeciality = (specialityId, attendenceMethodId) => {
    const exists = values.specialities.some(
      (s) => s.specialityId === specialityId
    );
    setFieldValue(
      "specialities",
      exists
        ? values.specialities.filter((s) => s.specialityId !== specialityId)
        : [...values.specialities, { specialityId, attendenceMethodId, type: "" }]
    );
  };

  const sortByName = (a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0);

  const clinicError = (index, field) =>
    touched.clinicAddresses?.[index]?.[field] &&
    errors.clinicAddresses?.[index]?.[field];

  return (
    <div style={{ backgroundColor: "#F8F8FA" }}>
      <Header />
      <CssBaseline />
      <div className={classes.page}>
        <div className={classes.paper}>
            <Typography className={classes.titulo}>
              CADASTRO DO PROFISSIONAL
            </Typography>
            <Typography className={classes.hintCenter}>
              Campos obrigatórios sinalizados com{" "}
              <span className={classes.required}>*</span>
            </Typography>

            <form noValidate>
              {/* DADOS PESSOAIS */}
              <Typography className={classes.sectionTitle}>
                DADOS PESSOAIS
              </Typography>

              <Grid container spacing={3}>
                <Grid
                  item
                  xs={12}
                  sm={4}
                  className={classes.photoBox}
                  style={{ marginTop: 10 }}
                >
                  <img
                    src={imagePreview || imgAp}
                    alt="Foto do profissional"
                    className={classes.avatar}
                  />
                  <input
                    id="photo-upload"
                    accept="image/*"
                    name="picture"
                    type="file"
                    onChange={handlePhoto}
                    style={{ display: "none" }}
                  />
                  <label htmlFor="photo-upload" className={classes.uploadButton}>
                    {uploadingPhoto
                      ? "Enviando..."
                      : values.picture
                      ? "Trocar foto *"
                      : "Selecionar foto *"}
                  </label>
                  {touched.picture && errors.picture && (
                    <div
                      style={{ color: "#f44336", fontSize: 12, marginTop: 6 }}
                    >
                      {errors.picture}
                    </div>
                  )}
                </Grid>

                <Grid item xs={12} sm={8}>
                  <div className={classes.label}>
                    NOME COMPLETO <span className={classes.required}>*</span>
                  </div>
                  <TextField
                    fullWidth
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                  />

                  <div className={classes.label}>
                    E-MAIL <span className={classes.required}>*</span>
                  </div>
                  <TextField
                    fullWidth
                    type="email"
                    name="email"
                    autoComplete="off"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlurEmail}
                    error={Boolean(
                      touched.email && (errors.email || emailExists)
                    )}
                    helperText={
                      touched.email &&
                      (errors.email ||
                        (emailExists ? "Este e-mail já está cadastrado." : ""))
                    }
                  />

                  <div className={classes.label}>
                    NÚMERO DE CONSELHO DE CLASSE{" "}
                    <span className={classes.required}>*</span>
                  </div>
                  <TextField
                    fullWidth
                    name="crfa"
                    autoComplete="off"
                    value={values.crfa}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.crfa && errors.crfa)}
                    helperText={touched.crfa && errors.crfa}
                  />

                  <div className={classes.label}>
                    CPF/CNPJ <span className={classes.required}>*</span>
                  </div>
                  <CpfCnpj
                    type="text"
                    name="cpf_cnpj"
                    value={values.cpf_cnpj}
                    onChange={(event) =>
                      setFieldValue("cpf_cnpj", event.target.value)
                    }
                    onBlur={handleBlur}
                    className="cpf-cnpj-input"
                    style={{
                      width: "100%",
                      height: 32,
                      marginTop: 16,
                      border: "none",
                      borderBottom: "1px solid #949494",
                      backgroundColor: "transparent",
                      fontSize: 16,
                    }}
                  />
                  {touched.cpf_cnpj && errors.cpf_cnpj && (
                    <div style={{ color: "#f44336", fontSize: 12 }}>
                      {errors.cpf_cnpj}
                    </div>
                  )}
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <div className={classes.label}>
                    SENHA <span className={classes.required}>*</span>
                  </div>
                  <TextField
                    fullWidth
                    type="password"
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.password && errors.password)}
                    helperText={
                      (touched.password && errors.password) ||
                      "Mín. 6 caracteres, com letra maiúscula, número e caractere especial."
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div className={classes.label}>
                    CONFIRMAR SENHA <span className={classes.required}>*</span>
                  </div>
                  <TextField
                    fullWidth
                    type="password"
                    name="confirmPassword"
                    value={values.confirmPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(
                      touched.confirmPassword && errors.confirmPassword
                    )}
                    helperText={
                      touched.confirmPassword && errors.confirmPassword
                    }
                  />
                </Grid>
              </Grid>

              {/* CURRÍCULO */}
              <Typography className={classes.sectionTitle}>CURRÍCULO</Typography>

              <div className={classes.label}>
                FORMAÇÃO ACADÊMICA <span className={classes.required}>*</span>
              </div>
              <Select
                placeholder="Selecione"
                options={profFormation}
                isSearchable={false}
                value={
                  profFormation.find((f) => f.value === values.formation) || null
                }
                onChange={(option) => setFieldValue("formation", option.value)}
              />
              {touched.formation && errors.formation && (
                <div style={{ color: "#f44336", fontSize: 12 }}>
                  {errors.formation}
                </div>
              )}

              <div className={classes.label}>
                TITULAÇÃO MÁXIMA <span className={classes.required}>*</span>
              </div>
              <Select
                placeholder="Selecione"
                options={profTitle}
                isSearchable={false}
                value={profTitle.find((t) => t.value === values.title) || null}
                onChange={(option) => setFieldValue("title", option.value)}
              />
              {touched.title && errors.title && (
                <div style={{ color: "#f44336", fontSize: 12 }}>
                  {errors.title}
                </div>
              )}

              <div className={classes.label}>INFORMAÇÕES ADICIONAIS</div>
              <TextField
                fullWidth
                multiline
                maxRows={5}
                inputProps={{ maxLength: 500 }}
                name="description"
                value={values.description}
                onChange={handleChange}
              />

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <div className={classes.label}>
                    TELEFONE <span className={classes.required}>*</span>
                  </div>
                  <InputMask
                    mask={phoneMask(values.phone)}
                    maskChar={null}
                    value={values.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    {() => (
                      <TextField
                        fullWidth
                        name="phone"
                        error={Boolean(touched.phone && errors.phone)}
                        helperText={touched.phone && errors.phone}
                      />
                    )}
                  </InputMask>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div className={classes.label}>
                    WHATSAPP <span className={classes.required}>*</span>
                  </div>
                  <InputMask
                    mask="(99) 99999-9999"
                    value={values.whatsapp}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    {() => (
                      <TextField
                        fullWidth
                        name="whatsapp"
                        error={Boolean(touched.whatsapp && errors.whatsapp)}
                        helperText={touched.whatsapp && errors.whatsapp}
                      />
                    )}
                  </InputMask>
                </Grid>
              </Grid>

              {/* ATENDIMENTO */}
              <Typography className={classes.sectionTitle}>
                ATENDIMENTO
              </Typography>
              <Typography className={classes.hint}>
                Selecione como gostaria de atender seus pacientes
              </Typography>
              <Grid container spacing={2} style={{ marginTop: 4 }}>
                {attendenceMethods.map((method) => (
                  <Grid item key={method.id} xs={6} sm={3}>
                    <FormGroup>
                      <StyledCheckbox
                        checked={values.attendance.includes(method.id)}
                        value={method.id}
                        onChange={() => toggleAttendance(method.id)}
                        label={method.name}
                        id={`attendance-${method.id}`}
                      />
                    </FormGroup>
                  </Grid>
                ))}
              </Grid>

              {values.attendanceMethods.map((method, index) => {
                const methodData = attendenceMethods.find(
                  (m) => m.id === method.attendenceMethodId
                );
                return (
                  <div className={classes.clinicBox} key={method.attendenceMethodId}>
                    <Typography
                      className={classes.label}
                      style={{ textAlign: "center" }}
                    >
                      ATENDIMENTO {methodData?.name}
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <div className={classes.label}>VALOR (R$)</div>
                        <TextField
                          fullWidth
                          name={`attendanceMethods[${index}].value`}
                          value={method.value}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div className={classes.label}>DURAÇÃO (minutos)</div>
                        <NumberFormat
                          customInput={TextField}
                          fullWidth
                          name={`attendanceMethods[${index}].schedule`}
                          value={method.schedule}
                          onChange={handleChange}
                        />
                      </Grid>
                    </Grid>
                    <div className={classes.label} style={{ textAlign: "center" }}>
                      HORÁRIOS DISPONÍVEIS
                    </div>
                    <Grid container spacing={2} justifyContent="center">
                      {PERIODS.map((period) => (
                        <Grid item key={period.value} xs={4} sm={2}>
                          <FormGroup>
                            <StyledCheckbox
                              checked={method.period.includes(period.value)}
                              onChange={() =>
                                togglePeriod(index, period.value)
                              }
                              label={period.label}
                              id={`period-${index}-${period.value}`}
                            />
                          </FormGroup>
                        </Grid>
                      ))}
                    </Grid>
                  </div>
                );
              })}

              {/* ESPECIALIDADES */}
              {values.attendance.map((attendanceId) => {
                const methodData = attendenceMethods.find(
                  (m) => m.id === attendanceId
                );
                const specs = specialities
                  .filter(
                    (s) =>
                      s.attendenceMethod?.id?.toString() ===
                      attendanceId.toString()
                  )
                  .sort(sortByName);
                if (specs.length === 0) return null;
                return (
                  <Grid container spacing={2} key={`spec-${attendanceId}`}>
                    <Grid item xs={12}>
                      <div className={classes.label}>
                        ESPECIALIDADES —{" "}
                        {methodData?.name?.toUpperCase() === "TELEATENDIMENTO"
                          ? "TELEATENDIMENTO"
                          : "ATENDIMENTO PRESENCIAL"}
                      </div>
                    </Grid>
                    {specs.map((speciality) => (
                      <Grid item key={speciality.id} xs={6} sm={3}>
                        <FormGroup>
                          <StyledCheckbox
                            checked={values.specialities.some(
                              (s) => s.specialityId === speciality.id
                            )}
                            onChange={() =>
                              toggleSpeciality(speciality.id, attendanceId)
                            }
                            label={speciality.name}
                            id={`speciality-${attendanceId}-${speciality.id}`}
                          />
                        </FormGroup>
                      </Grid>
                    ))}
                  </Grid>
                );
              })}

              {/* CONVÊNIOS */}
              <Typography className={classes.sectionTitle}>
                ACEITA CONVÊNIO?
              </Typography>
              <Typography className={classes.hint}>
                Se sim, selecione os convênios aceitos
              </Typography>
              <Grid container spacing={2} style={{ marginTop: 4 }}>
                {[...insurances].sort(sortByName).map((insurance) => (
                  <Grid item key={insurance.id} xs={6} sm={3}>
                    <FormGroup>
                      <StyledCheckbox
                        checked={values.insurance.includes(insurance.id)}
                        value={insurance.id}
                        onChange={() => toggleInsurance(insurance.id)}
                        label={insurance.name}
                        id={`insurance-${insurance.id}`}
                      />
                    </FormGroup>
                  </Grid>
                ))}
              </Grid>

              {/* CONSULTÓRIOS */}
              <Typography className={classes.sectionTitle}>
                INFORMAÇÕES DO CONSULTÓRIO
              </Typography>

              {values.clinicAddresses.map((clinic, index) => (
                <Fragment key={index}>
                  <div className={classes.clinicBox}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <div className={classes.label}>
                          NOME DO CONSULTÓRIO{" "}
                          <span className={classes.required}>*</span>
                        </div>
                        <TextField
                          fullWidth
                          name={`clinicAddresses[${index}].clinic_name`}
                          value={clinic.clinic_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(clinicError(index, "clinic_name"))}
                          helperText={clinicError(index, "clinic_name")}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div className={classes.label}>
                          CONTATO DO CONSULTÓRIO{" "}
                          <span className={classes.required}>*</span>
                        </div>
                        <InputMask
                          mask={phoneMask(clinic.clinic_contact)}
                          maskChar={null}
                          value={clinic.clinic_contact}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          {() => (
                            <TextField
                              fullWidth
                              name={`clinicAddresses[${index}].clinic_contact`}
                              error={Boolean(
                                clinicError(index, "clinic_contact")
                              )}
                              helperText={clinicError(index, "clinic_contact")}
                            />
                          )}
                        </InputMask>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <div className={classes.label}>
                          CEP <span className={classes.required}>*</span>
                        </div>
                        <InputMask
                          mask="99999-999"
                          value={clinic.zipcode}
                          onChange={handleChange}
                          onBlur={(event) => {
                            handleBlur(event);
                            checkCEP(event, index);
                          }}
                        >
                          {() => (
                            <TextField
                              fullWidth
                              name={`clinicAddresses[${index}].zipcode`}
                              error={Boolean(clinicError(index, "zipcode"))}
                              helperText={clinicError(index, "zipcode")}
                            />
                          )}
                        </InputMask>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div className={classes.label}>
                          ENDEREÇO <span className={classes.required}>*</span>
                        </div>
                        <TextField
                          fullWidth
                          name={`clinicAddresses[${index}].street`}
                          value={clinic.street}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(clinicError(index, "street"))}
                          helperText={clinicError(index, "street")}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <div className={classes.label}>
                          NÚMERO <span className={classes.required}>*</span>
                        </div>
                        <NumberFormat
                          customInput={TextField}
                          fullWidth
                          name={`clinicAddresses[${index}].number`}
                          value={clinic.number}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(clinicError(index, "number"))}
                          helperText={clinicError(index, "number")}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <div className={classes.label}>
                          BAIRRO <span className={classes.required}>*</span>
                        </div>
                        <TextField
                          fullWidth
                          name={`clinicAddresses[${index}].district`}
                          value={clinic.district}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(clinicError(index, "district"))}
                          helperText={clinicError(index, "district")}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <div className={classes.label}>COMPLEMENTO</div>
                        <TextField
                          fullWidth
                          name={`clinicAddresses[${index}].complement`}
                          value={clinic.complement}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <div className={classes.label}>
                          ESTADO <span className={classes.required}>*</span>
                        </div>
                        <TextField
                          fullWidth
                          name={`clinicAddresses[${index}].state`}
                          value={clinic.state}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(clinicError(index, "state"))}
                          helperText={clinicError(index, "state")}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div className={classes.label}>
                          CIDADE <span className={classes.required}>*</span>
                        </div>
                        <TextField
                          fullWidth
                          name={`clinicAddresses[${index}].city`}
                          value={clinic.city}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(clinicError(index, "city"))}
                          helperText={clinicError(index, "city")}
                        />
                      </Grid>
                    </Grid>
                    {values.clinicAddresses.length > 1 && (
                      <div style={{ textAlign: "center" }}>
                        <Button
                          style={{
                            backgroundColor: "#ff5e8f",
                            borderRadius: "25px",
                            color: "#fff",
                            padding: "10px 20px",
                            marginTop: 10,
                          }}
                          onClick={() => removeClinic(index)}
                        >
                          REMOVER CONSULTÓRIO
                        </Button>
                      </div>
                    )}
                  </div>
                </Fragment>
              ))}

              <div className={classes.addClinicBox}>
                <Button
                  style={{
                    backgroundColor: "#54B5CF",
                    borderRadius: "25px",
                    color: "#fff",
                    padding: "10px 24px",
                    marginTop: 8,
                  }}
                  onClick={addClinic}
                >
                  Acrescentar outro consultório
                </Button>
              </div>

              {/* SUBMIT */}
              <div style={{ textAlign: "center" }}>
                <Button
                  type="button"
                  className={classes.submit}
                  disabled={submitting || uploadingPhoto}
                  onClick={onClickSubmit}
                >
                  {submitting ? "ENVIANDO..." : "CONCLUIR CADASTRO"}
                  {submitting && (
                    <span style={{ marginLeft: 10 }}>
                      <CircularProgress />
                    </span>
                  )}
                </Button>
              </div>
            </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
